import styled from 'styled-components';


export const Wrapper = styled.form`
  z-index: 1;
  position: absolute;
  right: 100%;
  top: 30%;
  width: 440px;
  height: auto;
  background: #fff;
  border-radius: 15px;
  padding: 40px 30px;
  box-shadow: rgb(0 0 0 / 15%) 0px 5px 20px;
  color: #2253f5 ;
  font-family: Montserrat !important;
  text-align: center;

  svg {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }

  p {
    color: #2253f5;
    font-family: Montserrat !important;
    width: 290px;
    margin: auto;
    font-size: 27px;
    line-height: 22px;
    font-weight: 600;
    margin-bottom: 16px !important;
  }

  span {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 22px !important;
    display: block;
  }

  button {
    svg {
      position: unset;
    }
    height: 40px;
    border: 1px solid white;
    cursor: pointer;
    color: var(--primary-color) !important;
    background: rgb(252, 255, 124) !important;
    border-radius: 100px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
    font-family: Montserrat !important;
    font-weight: bold !important;
    font-size: 16px !important;
  }
`;
